import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import { usePlexRoute } from '../details/usePlexRoute';
import { TimelineView } from '../timeline/TimelineView';
import { NotificationsView } from './NotificationsView/NotificationsView';
import { PlexBaseTimeline } from './PlexBaseTimeline';
import { PlexPostTimeline } from './PlexPostTimeline';
import { PlexSummary } from './PlexSummary';
import { TasksView } from './TasksView';

export const FeedContainer = React.memo(
  (): React.ReactElement => {
    const classes = useStyles();
    const [plexRoute] = usePlexRoute();

    return (
      <div className={classes.root}>
        <div className={classes.rootContent}>
          {((): React.ReactElement | null => {
            switch (plexRoute.page) {
              case 'feed':
                return <PlexPostTimeline />;
              case 'timeline':
                return <TimelineView />;
              case 'base':
                return <PlexBaseTimeline />;
              case 'notifications':
                return <NotificationsView />;
              case 'tasks':
                return <TasksView />;
              case 'search':
                return null;
            }
          })()}
        </div>
        {plexRoute.plexSummary != null && <PlexSummary plexPermalink={plexRoute.plexSummary.permalink} />}
      </div>
    );
  }
);

export const PLEX_FEED_MIN_WIDTH = 692;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
    flex: 1,
  },
  rootContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
    minWidth: PLEX_FEED_MIN_WIDTH,
  },
}));
